export default __webpack_public_path__ + "fc9ca9847387c9138854f053a7204e3c.svg";